import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function MoveUp({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>MoveUp</title>
      <rect
        x="14"
        y="4"
        width="6"
        height="6"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        x="14"
        y="14"
        width="6"
        height="6"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 19.373C8.4087 19.373 6.88258 18.7409 5.75736 17.6157C4.63214 16.4905 4 14.9643 4 13.373C4 11.7817 4.63214 10.2556 5.75736 9.13041C6.88258 8.00519 8.4087 7.37305 10 7.37305"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.396 5.54443L10.9256 6.98457L9.48551 9.51422"
        stroke={color ?? 'currentColor'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
